export default "__VITE_ASSET__bac3087a__"